import React from 'react';
import './TransportLoader.css';

export default function TransportLoader() {
  const publicPath = process.env.PUBLIC_URL || '';

  return (
    <div className="transport-loader" role="status" aria-live="polite">
      <div className="transport-loader__stage">
        <div className="transport-loader__trail" />
        <div className="transport-loader__glow" />

        <div className="transport-loader__vehicle transport-loader__vehicle--truck" aria-hidden="true">
          <img
            src={`${publicPath}/svg/truck.svg`}
            alt="Ilustracion de camion en movimiento"
            loading="lazy"
          />
        </div>

        <div className="transport-loader__vehicle transport-loader__vehicle--ship" aria-hidden="true">
          <img
            src={`${publicPath}/svg/vessel.svg`}
            alt="Ilustracion de buque en movimiento"
            loading="lazy"
          />
        </div>

        <div className="transport-loader__vehicle transport-loader__vehicle--plane" aria-hidden="true">
          <img
            src={`${publicPath}/svg/airplane.svg`}
            alt="Ilustracion de avion despegando"
            loading="lazy"
          />
        </div>
      </div>
      <p className="transport-loader__text">Preparando tu experiencia logística…</p>
    </div>
  );
}
